// extracted by mini-css-extract-plugin
export default {"notes":"Hw-40E7CkezSideJ8UzAAg=="};